export default __webpack_public_path__ + "static/media/belem tårnet.f8473e7d.svg";